<template>
  <v-card
    text
    flat
  >
    <v-data-table
      :headers="headers"
      :items="specifications"
      :loading="loading"
      :items-per-page-options="rowsPerPageItems"
      :items-per-page-text="rowsPerPageText"
      :custom-sort="filteredSpecifications"
      :hide-default-footer="specifications.length < 11"
      no-data-text="Даних немає"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <ReferenceTitle
              class="primary--text"
              component-name="Specification"
              :id="item.id"
              :title="item.id"
            />
          </td>
          <td>
            {{ item.date | date }}
          </td>
          <td>
            {{ item.author ? item.author.title : "" }}
          </td>
          <td>
            {{ item.title }}
          </td>
          <td>
            {{ item.tAvg }}
          </td>
          <td>
            <v-chip
              :color="getColor(item, 'estimateMin')"
              outlined
            >
              <template>
                {{ item.estimateMin }}
              </template>
            </v-chip>
          </td>
          <td>
            <v-chip
              :color="getColor(item, 'estimateNorm')"
              outlined
            >
              <template>
                {{ item.estimateNorm }}
              </template>
            </v-chip>
          </td>
          <td>
            <v-chip
              :color="getColor(item, 'estimateMax')"
              outlined
            >
              <template>
                {{ item.estimateMax }}
              </template>
            </v-chip>
          </td>
          <td>
            {{ item.totalTimeSpentSeconds | secondsToHours }}
          </td>
          <td>
            <v-chip
              :color="getColor(item, 'factWithGrades')"
              outlined
            >
              <template>
                {{ item.factWithGrades }}
              </template>
            </v-chip>
          </td>
          <td>
            <v-progress-circular
              :value="item.devProgress"
              :color="
                item.devProgress === 0
                  ? 'grey'
                  : item.devProgress > 100
                    ? 'red'
                    : item.color
              "
              size="45"
            >
              {{ `${item.devProgress}%` }}
            </v-progress-circular>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import * as clientsApi from "../../../backend/clientsApi.js";
import PaymentTypeLabel from "../../../components/enums/PaymentTypeLabel.vue";

export default {
  components: {
    ReferenceTitle() {
      return import("../../../components/ReferenceTitle.vue");
    },
    PaymentTypeLabel,
  },
  props: ["id"],
  data: () => ({
    headers: [
      { text: "id", sortable: false },
      { text: "Дата", sortable: false },
      { text: "Автор", sortable: false },
      { text: "Найменування", sortable: false },
      { text: "t(avg)", sortable: false },
      { text: "min", sortable: false, color: "" },
      { text: "norm", sortable: false, color: "" },
      { text: "max", sortable: false, color: "" },
      { text: "Факт", sortable: false },
      { text: "Факт з грейдами", sortable: false, color: "" },
      { text: "Прогрес розробки", sortable: false, color: "" },
    ],
    specifications: [],
    loading: false,
    rowsPerPageItems: [5, 10, 25, { text: "Всі", value: -1 }],
    rowsPerPageText: "Рядків на сторінці:",
  }),
  created() {
    this.loading = true;
    this.getSpecifications();
    this.loading = false;
  },
  methods: {
    async getSpecifications() {
      this.specifications = await clientsApi.getSpecifications(this.id);
    },
    filteredSpecifications() {
      return this.specifications.sort((a, b) => {
        const dateA = a.date;
        const dateB = b.date;

        if (dateA < dateB) {
          return 1;
        }
        if (dateA > dateB) {
          return -1;
        }
        return 0;
      });
    },
    getColor(item, estimateName) {
      switch (true) {
        case estimateName === "estimateMin" &&
          item.factWithGrades <= item.estimateMin:
          item.color = "green";
          return "green";
        case estimateName === "estimateNorm" &&
          item.factWithGrades > item.estimateMin &&
          item.factWithGrades <= item.estimateNorm:
          item.color = "yellow darken-2";
          return "yellow darken-2";
        case estimateName === "estimateMax" &&
          item.factWithGrades > item.estimateNorm:
          item.color = "red";
          return "red";
        case estimateName === "factWithGrades":
          return item.color;
        default:
          return "default";
      }
    },
  },
};
</script>
